const req = require.context('.', true, /\.\/[^/]+\/[^/]+\/index\.[j|t]sx?$/)

req.keys().forEach((key) => {
  const componentName = key.replace(/^.+\/([^/]+)\/index\.[j|t]sx?/, '$1')
  module.exports[componentName] = req(key).default
})
